export default {
    bindings: {
        'password': '=',
        'strength': '=',
        'saving': '<',
    },
    controller: 'passwordInputController',
    template: require('../views/password.input.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/components/password.input.component.js